export default class SwitchUniverse {
    constructor(elm, args) {
        // ESC Universe
        const switchButtonMainNavDesktopEsc = document.getElementById('switchButtonMainNavDesktop-esc');
        const switchButtonMainNavMobileEsc = document.getElementById('switchButtonMainNavMobile-esc');
        const switchButtonFooterEsc = document.getElementById('switchButtonFooter-esc');

        // EBE Universe
        const switchButtonMainNavDesktopEbe = document.getElementById('switchButtonMainNavDesktop-ebe');
        const switchButtonMainNavMobileEbe = document.getElementById('switchButtonMainNavMobile-ebe');
        const switchButtonFooterEbe = document.getElementById('switchButtonFooter-ebe');

        // Common frontpage hero stuff
        // Fade out hero elements (except decoration layers).
        // First step when switching universe via one of the switch buttons (see ESC & EBE Universe IDs above)
        function fadeOut() {
            document.body.classList.add('body--prepare-fade-out');
            requestAnimationFrame(() => {
                document.body.classList.add('body--fade-out');
            });
        }

        // Switch from website birn-partners.com to board-education.com
        // Need to change the href according to environment (local, development, live)
        // The proper live environment is not yet set up
        function switchToExecutiveBoardEducation() {
            setTimeout(function () { location.href = args.ebeUrl; }, 1250);
        }

        if (document.body.classList.contains('body--pending-animation')) {
            document.body.classList.add('body--animate-in');
            document.body.classList.remove('body--pending-animation');
            window.history.pushState({}, document.title, removeURLParameter(removeURLParameter(document.location.href, 'animateIn'), 'menu'));

            // setTimeout(() => {
            //    window.location.href = `${x.dataset.url}?animate=1${menu}`;
            // }, 1900)
        }

        // Switch from website board-education.com to birn-partners.com
        // Need to change the href according to environment (local, development, live)
        // The proper live environment is not yet set up
        function switchToExecutiveSearchConsulting() {
            setTimeout(function () { location.href = args.escUrl }, 1250);
        }

        function removeURLParameter(url, parameter) {
            // prefer to use l.search if you have a location/link object
            const urlparts = url.split('?');
            if (urlparts.length >= 2) {

                const prefix = encodeURIComponent(parameter) + '=';
                const pars = urlparts[1].split(/[&;]/g);

                // reverse iteration as may be destructive
                for (let i = pars.length; i-- > 0;) {
                    // idiom for string.startsWith
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }

                return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            }
            return url;
        }

        if (switchButtonMainNavDesktopEsc !== null) {
            switchButtonMainNavDesktopEsc.onclick = function () {
                fadeOut();
                switchToExecutiveBoardEducation();
            };
        }

        if (switchButtonMainNavMobileEsc !== null) {
            switchButtonMainNavMobileEsc.onclick = function () {
                fadeOut();
                switchToExecutiveBoardEducation();
            };
        }

        if (switchButtonFooterEsc !== null) {
            switchButtonFooterEsc.onclick = function () {
                fadeOut();
                switchToExecutiveBoardEducation();
            };
        }

        if (switchButtonMainNavDesktopEbe !== null) {
            switchButtonMainNavDesktopEbe.onclick = function () {
                fadeOut();
                switchToExecutiveSearchConsulting();
            };
        }

        if (switchButtonMainNavMobileEbe !== null) {
            switchButtonMainNavMobileEbe.onclick = function () {
                fadeOut();
                switchToExecutiveSearchConsulting();
            };
        }

        if (switchButtonFooterEbe !== null) {
            switchButtonFooterEbe.onclick = function () {
                fadeOut();
                switchToExecutiveSearchConsulting();
            };
        }
    }
}
